import * as PropTypes from 'prop-types'
import classNames from 'classnames'

import variablesStyles from '/styles/variables.css'
import iconsStyles from './Icons.css'

import { TextCopy } from '/react/library/'

const defaultPropTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  hasBox: PropTypes.bool,
  height: PropTypes.number,
  isLight: PropTypes.bool,
  width: PropTypes.number
}

/*
How to create an icon:

1. Export shape from Sketch: "Copy SVG Code"
2. Paste markup into SVGOMG to clean up the code: https://jakearchibald.github.io/svgomg/
3. Only copy the path definition and check the fill rule
4. Set the correct width, height and viewBox
 */

class Icon extends React.PureComponent {
  render () {
    const {
      className,
      fill,
      hasBox,
      height,
      isLight,
      type,
      viewBox,
      width,
      ...restProps
    } = this.props

    const defaultFill = isLight ? variablesStyles.colorWhite : variablesStyles.colorBlueDark
    const pathFill = fill ? fill : defaultFill

    return (
      <span
        className={classNames(
          iconsStyles.icon,
          {
            [iconsStyles.hasBox]: hasBox,
            [className]: className
          }
        )}
        {...restProps}
      >
        <svg width={width} height={height} viewBox={viewBox} xmlns='http://www.w3.org/2000/svg'>
          { type === 'menu' && (<path fill={pathFill} fillRule='nonzero' d='M0 2V0h16v2H0zm0 12v-2h16v2H0zm0-6V6h16v2H0z' />)}
          { type === 'close' && (<path fill={pathFill} fillRule='nonzero' d='M8 6.532L14.532 0 16 1.468 9.468 8 16 14.532 14.532 16 8 9.468 1.468 16 0 14.532 6.532 8 0 1.468 1.468 0 8 6.532z' />)}
          { type === 'plus' && (<path fill={pathFill} fillRule='nonzero' d='M9 7h7v2H9v7H7V9H0V7h7V0h2v7z' />)}
          { type === 'audioOn' && (<path fill={pathFill} fillRule='nonzero' d='M2 14H0V4h2v10zm6 0H6V9h2v5zm6 0h-2V0h2v14z' />)}
          { type === 'audioOff' && (<path fill={pathFill} fillRule='nonzero' d='M2 2H0V0h2v2zm6 0H6V0h2v2zm6 0h-2V0h2v2z' />)}
          { type === 'link' && (<path fill={pathFill} fillRule='nonzero' d='M10.074 6.494l1.432 1.431-3.58 3.58-1.432-1.432 3.58-3.58zm-5.728 0l1.432 1.431-2.863 2.864a3.037 3.037 0 1 0 4.295 4.295l2.864-2.864 1.432 1.432-2.864 2.864a5.063 5.063 0 0 1-7.16-7.159l2.864-2.863zm9.308 5.01l-1.432-1.431 2.863-2.864a3.037 3.037 0 1 0-4.295-4.295L7.926 5.778 6.494 4.346l2.864-2.863a5.063 5.063 0 0 1 7.16 7.158l-2.864 2.864z' />)}
          { type === 'jumpTo' && (<path fill={pathFill} fillRule='nonzero' d='M13.298 7.165L9.095 2.962l1.438-1.438L17 7.992l-6.467 6.467-1.438-1.437 3.825-3.825H0V0h2.033v7.165h11.265z' />)}
          { type === 'dash' && (<path fill={pathFill} fillRule='nonzero' d='M0 2V0h16v2z' />)}
          { type === 'chevronDown' && (<path fill={pathFill} fillRule='nonzero' d='M16.615 0L18 1.385l-9 9-9-9L1.385 0 9 7.615z' />)}
          { type === 'chevronUp' && (<path fill={pathFill} fillRule='nonzero' d='M16.615 10.385L9 2.769l-7.615 7.616L0 9l9-9 9 9z' />)}
          { type === 'chevronRight' && (<path fill={pathFill} fillRule='nonzero' d='M0 16.615L7.618 9 0 1.385 1.385 0l9.003 9-9.003 9z' />)}
          { type === 'chevronLeft' && (<path fill={pathFill} fillRule='nonzero' d='M10.388 16.615L9.003 18 0 9l9.003-9 1.385 1.385L2.77 9z' />)}
          { type === 'checkMark' && (<path fill={pathFill} fillRule='nonzero' d='M16.618 0L18 1.383 6.675 12.73 0 5.699l1.382-1.383 5.293 5.65z' />)}
          { type === 'search' && (<path fill={pathFill} fillRule='nonzero' d='M9.426 10.926a6 6 0 1 1 1.428-1.4L16 15l-1.414 1.414-5.16-5.488zM6 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8z' />)}
          { type === 'drag' && (<path fill={pathFill} fillRule='nonzero' d='M20.087 7.524H3.912l4.035 4.036-1.445 1.444L0 6.502 6.502 0l1.445 1.445-4.035 4.036h16.175l-4.038-4.036L17.494 0 24 6.502l-6.506 6.503-1.445-1.446 4.038-4.035z' />)}
          { type === 'rotate' && (<path fill={pathFill} fillRule='nonzero' d='M22 11.674L24.674 9 26 10.326l-5 5-5-5L17.326 9 20 11.674V11c0-2.557-1.07-4.94-2.918-6.634A8.962 8.962 0 0 0 11 2a8.971 8.971 0 0 0-6.602 2.883A8.963 8.963 0 0 0 2 11a9 9 0 0 0 9 9h1v2h-1C4.925 22 0 17.075 0 11c0-2.81 1.06-5.457 2.931-7.476A10.97 10.97 0 0 1 11 0c2.79 0 5.42 1.044 7.434 2.892A10.972 10.972 0 0 1 22 11v.674z' />)}
          { type === 'arrowRight' && (<path fill={pathFill} fillRule='nonzero' d='M13.052 6.988l-5.531-5.53L8.979 0 17 8.019l-8.021 8.018-1.458-1.457 5.531-5.53H0V6.988h13.052z' />)}
          { type === 'grid' && (<path fill={pathFill} fillRule='nonzero' d='M16 2h-6v6h6V2zm2 0v16H0V0h18v2zm-2 14v-6h-6v6h6zM8 2H2v6h6V2zm0 14v-6H2v6h6z' />)}
          { type === 'facebook' && (<path fill={pathFill} fillRule='evenodd' d='M5.32 18V8.999h2.366L8 5.897H5.32l.004-1.552c0-.81.073-1.243 1.18-1.243h1.48V0H5.615C2.773 0 1.772 1.505 1.772 4.035v1.862H0V9h1.772V18H5.32z' />)}
          { type === 'twitter' && (<path fill={pathFill} fillRule='evenodd' d='M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z' />)}
          { type === 'youTube' && (<path fill={pathFill} fillRule='evenodd' d='M17.82 2.589s.18 1.38.18 2.76v1.295c0 1.381-.18 2.762-.18 2.762s-.176 1.175-.715 1.693c-.685.68-1.452.683-1.804.723C12.782 11.995 9 12 9 12s-4.68-.04-6.12-.172c-.4-.07-1.3-.05-1.985-.73C.355 10.582.18 9.407.18 9.407S0 8.026 0 6.644V5.35c0-1.38.18-2.761.18-2.761S.355 1.413.895.895C1.58.215 2.347.212 2.699.173 5.218 0 8.996 0 8.996 0h.008s3.778 0 6.297.173c.352.04 1.119.042 1.804.722.539.518.715 1.694.715 1.694zM7.142 8.213l4.862-2.389L7.141 3.42v4.794z' />)}
          { type === 'instagram' && (<path fill={pathFill} fillRule='evenodd' d='M12.985 0A5.02 5.02 0 0 1 18 5.015v7.97A5.02 5.02 0 0 1 12.985 18h-7.97A5.021 5.021 0 0 1 0 12.985v-7.97A5.021 5.021 0 0 1 5.015 0h7.97zM14 3c-.546 0-1 .432-1 1 0 .545.432 1 1 1 .568 0 1.022-.455 1-1 0-.545-.455-1-1-1zM9 4.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9zm0 7.561A3.065 3.065 0 0 1 5.939 9 3.065 3.065 0 0 1 9 5.939c1.7 0 3.061 1.36 3.061 3.061A3.065 3.065 0 0 1 9 12.061z' />)}
          { type === 'envelope' && (<path fill={pathFill} fillRule='evenodd' d='M16 1.35L8 4.906 0 1.35V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v.35zm0 2.189V11a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V3.539l7.188 3.194a2 2 0 0 0 1.624 0L16 3.54z' />)}
          { type === 'pause' && (<path fill={pathFill} fillRule='nonzero' d='M0 0h4v14H0V0zm8 0h4v14H8V0z' />)}
          { type === 'play' && (<path fill={pathFill} fillRule='evenodd' d='M0 0v16l16-8z' />)}
          { type === 'share' && (<path fill={pathFill} fillRule='evenodd' d='M4.885 8.666l8.181-5.035a3 3 0 1 1 1.049 1.703L5.934 10.37a3.012 3.012 0 0 1 0 1.262l8.181 5.035a3 3 0 1 1-1.049 1.703l-8.181-5.035a3 3 0 1 1 0-4.668z' />)}
        </svg>
      </span>
    )
  }
}

export class IconWithText extends React.PureComponent {
  render () {
    const {
      className,
      icon,
      isLight,
      text,
      hasTextSpacing,
      iconAlignRight
    } = this.props

    const style = (hasTextSpacing) ? { style: {
      marginLeft: !iconAlignRight ? '10px' : null,
      marginRight: iconAlignRight ? '10px' : null,
    } } : null

    return (
      <div className={classNames(
        iconsStyles.iconWithText,
        { [className]: className }
      )}>
        {!iconAlignRight && icon}
        <TextCopy isInline isLight={isLight} {...style}>{text}</TextCopy>
        {iconAlignRight && icon}
      </div>
    )
  }
}

export class IconMenu extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <Icon type='menu' width='16' height='14' {...this.props} viewBox='0 0 16 14' />
    )
  }
}

export class IconClose extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <Icon type='close' width='16' height='16' {...this.props} viewBox='0 0 16 16' />
    )
  }
}

export class IconPlus extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <Icon type='plus' width='16' height='16' {...this.props} viewBox='0 0 16 16' />
    )
  }
}

export class IconAudioOn extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <Icon type='audioOn' width='14' height='14' {...this.props} viewBox='0 0 14 14' />
    )
  }
}

export class IconAudioOff extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <Icon type='audioOff' width='14' height='14' {...this.props} viewBox='0 -6 14 2' />
    )
  }
}

export class IconLink extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <Icon type='link' width='18' height='18' {...this.props} viewBox='0 0 18 18' />
    )
  }
}

export class IconJumpTo extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <Icon type='jumpTo' width='17' height='15' {...this.props} viewBox='0 0 17 14.46' />
    )
  }
}

export class IconDash extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <Icon type='dash' width='16' height='2' {...this.props} viewBox='0 0 16 2' />
    )
  }
}

export class IconChevronDown extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <Icon type='chevronDown' width='18' height='11' {...this.props} viewBox='0 0 18 10.38' />
    )
  }
}

export class IconChevronUp extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <Icon type='chevronUp' width='18' height='11' {...this.props} viewBox='0 0 18 10.38' />
    )
  }
}

export class IconChevronRight extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    const {
      className,
      ...restProps
    } = this.props

    return (
      <Icon type='chevronRight' width='11' height='18' className={classNames(
        className,
        iconsStyles.shiftRight
      )} {...restProps} viewBox='0 0 10.39 18' />
    )
  }
}

export class IconChevronLeft extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    const {
      className,
      ...restProps
    } = this.props

    return (
      <Icon type='chevronLeft' width='11' height='18' className={classNames(
        className,
        iconsStyles.shiftLeft
      )} {...restProps} viewBox='0 0 10.39 18' />
    )
  }
}

export class IconCheckMark extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <Icon type='checkMark' width='18' height='13' {...this.props} viewBox='0 0 18 12.73' />
    )
  }
}

export class IconSearch extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <Icon type='search' width='16' height='17' {...this.props} viewBox='0 0 16 16.41' />
    )
  }
}

export class IconDrag extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <Icon type='drag' width='24' height='13' {...this.props} viewBox='0 0 24 13' />
    )
  }
}

export class IconRotate extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <Icon type='rotate' width='26' height='22' {...this.props} viewBox='0 0 26 22' />
    )
  }
}

export class IconArrowRight extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <Icon type='arrowRight' width='17' height='17' {...this.props} viewBox='0 0 17 16.04' />
    )
  }
}

export class IconGrid extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <Icon type='grid' width='18' height='18' {...this.props} viewBox='0 0 18 18' />
    )
  }
}

export class IconFacebook extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <Icon type='facebook' width='8' height='18' {...this.props} viewBox='0 0 8 18' />
    )
  }
}

export class IconTwitter extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <Icon type='twitter' width='18' height='14' {...this.props} viewBox='0 0 1200 1227' />
    )
  }
}

export class IconYouTube extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <Icon type='youTube' width='18' height='12' {...this.props} viewBox='0 0 18 12' />
    )
  }
}

export class IconInstagram extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <Icon type='instagram' width='18' height='18' {...this.props} viewBox='0 0 18 18' />
    )
  }
}

export class IconEnvelope extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <Icon type='envelope' width='16' height='12' {...this.props} viewBox='0 0 16 12' />
    )
  }
}

export class IconPause extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <Icon type='pause' width='12' height='14' {...this.props} viewBox='0 0 12 14' />
    )
  }
}

export class IconPlay extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    const {
      className,
      ...restProps
    } = this.props

    return (
      <Icon type='play' width='16' height='16' className={classNames(
        className,
        iconsStyles.shiftRight
      )} {...restProps} viewBox='0 0 16 16' />
    )
  }
}

export class IconShare extends React.PureComponent {
  static propTypes = defaultPropTypes

  render () {
    return (
      <Icon type='share' width='19' height='22' {...this.props} viewBox='0 0 19 22' />
    )
  }
}